import { Controller, useForm } from 'react-hook-form';
import SelectFieldFormHook from 'src/components/Forms/Select';
import InputFieldFormHook from 'src/components/Forms/Inputs';
import { DatePicker, LoadingButton } from '@mui/lab';
import { Card, FormControl, Grid, TextField, Typography } from '@mui/material';

import { Search } from '@mui/icons-material';
import moment from 'moment';
import useCustomerNewReport from 'src/hooks/Reports/useCustomerNewReport';
import useUserProfile from 'src/hooks/Users/useUserProfile';
import { isAdmin } from 'src/utils/commons/checkRole';
import { PageMessageStatisticQuery } from 'src/types/Reports/pageReport.model';

type FindManagerProps = {
  isLoading?: boolean;
  onFindReport: (data: PageMessageStatisticQuery) => void;
};

function PageHeader({ onFindReport, isLoading }: FindManagerProps) {
  const { profile } = useUserProfile();
  const { handleSubmit, control, watch, setValue, register } = useForm<PageMessageStatisticQuery>({
    defaultValues: {
      fromDate: moment().startOf('month').format(),
      toDate: moment().format(),
      managerId: !isAdmin(profile.roleFId) ? profile.userId : undefined,
      page: 1,
      take: 50
    }
  });
  const onSubmit = async (data: PageMessageStatisticQuery) => {
    data.fromDate = moment(data.fromDate).startOf('month').startOf('date').format();
    data.toDate = moment(data.toDate).endOf('date').format();
    data.refresh = new Date().getTime();
    onFindReport && onFindReport(data);
  };

  const { filterProjectManager } = useCustomerNewReport();

  return (
    <Card className="p-8">
      <Typography sx={{ pb: 3 }} variant="h4">
        Báo cáo tin nhắn trang
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <div>
          <Grid container spacing={1} className="pt-12">
            <Grid item xs={12} md={3}>
              <SelectFieldFormHook
                register={register}
                id="managerId"
                name="managerId"
                label="Lọc theo PM"
                variant="outlined"
                dataOptions={filterProjectManager}
                defaultValue={`${filterProjectManager[0].value ?? 0}`}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Controller
                  control={control}
                  name="fromDate"
                  render={({ field: { value, onChange } }) => {
                    return (
                      <DatePicker
                        className="w-100"
                        inputFormat="dd/MM/yyyy"
                        views={['day']}
                        label="Từ ngày"
                        value={value}
                        onChange={e => onChange(e)}
                        renderInput={params => <TextField {...params} />}
                      />
                    );
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Controller
                  control={control}
                  name="toDate"
                  render={({ field: { value, onChange } }) => {
                    return (
                      <DatePicker
                        minDate={watch('fromDate')}
                        views={['day']}
                        inputFormat="dd/MM/yyyy"
                        label="Đến ngày"
                        value={value}
                        onChange={newValue => onChange(newValue)}
                        renderInput={params => <TextField {...params} />}
                      />
                    );
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <InputFieldFormHook register={register} name="keyword" label="Nhập tên/id page" variant="outlined" />
            </Grid>
          </Grid>
        </div>
        <div className="flex justify-end pt-4">
          <div>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              startIcon={<Search />}
              onClick={handleSubmit(onSubmit)}
            >
              Xem
            </LoadingButton>
          </div>
        </div>
      </form>
    </Card>
  );
}

export default PageHeader;
